/* Commerce behaviour.

   Everything in this file is Shopify-only: the cart, predictive search, and the
   product page's colour and size pickers. tiger.js is the static site's own
   script carried over almost untouched, and keeping the two apart is what lets
   it stay diffable against static-site/js/main.js.

   Two rules this file follows throughout:

   1. Money is never formatted here. Anything showing a price is re-rendered by
      the server through the Section Rendering API, so the shop's own currency
      format is the single source of truth and "JOD 24" stays "JOD 24" without a
      formatter in JavaScript that could disagree with the one at checkout.

   2. Every control it enhances already works without it. The swatches are
      links, the add button is a real form submit, the search field is a GET
      form. JS makes them quiet; it is not what makes them function. */
(function () {
  'use strict';

  var CFG = window.Tiger || (window.Tiger = {});
  var ROUTES = CFG.routes || {};
  var STRINGS = CFG.strings || {};

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || STRINGS.error);
        return data;
      });
    });
  }

  function fetchSection(url) {
    return fetch(url, { headers: { 'Accept': 'text/html' } })
      .then(function (r) {
        if (!r.ok) throw new Error(STRINGS.error);
        return r.text();
      })
      .then(function (html) {
        return new DOMParser().parseFromString(html, 'text/html');
      });
  }

  /* ---- cart ------------------------------------------------------------- */
  /* The tray is re-rendered from the header section rather than assembled from
     /cart.js, so line prices and the subtotal come back formatted by the shop.
     Only the count badge is touched directly, and it is a plain integer. */

  var trayBody = document.querySelector('[data-cart-tray-body]');

  function refreshCart() {
    return fetchSection(ROUTES.root + '?section_id=header').then(function (doc) {
      var nextBody = doc.querySelector('[data-cart-tray-body]');
      if (nextBody && trayBody) trayBody.innerHTML = nextBody.innerHTML;

      var nextCount = doc.querySelector('[data-cart-count]');
      var count = document.querySelector('[data-cart-count]');
      if (nextCount && count) {
        count.textContent = nextCount.textContent;
        count.hidden = nextCount.textContent.trim() === '0';
      }

      /* the section HTML arrives in English; a reader who switched to Arabic
         gets the fresh contents re-swapped before they ever see them */
      if (window.Tiger && Tiger.relocalize) Tiger.relocalize();
    });
  }

  function addToCart(variantId, quantity) {
    return post(ROUTES.cartAdd, { items: [{ id: Number(variantId), quantity: quantity || 1 }] })
      .then(refreshCart)
      .then(function () {
        if (CFG.openCart) CFG.openCart();
      });
  }

  /* Quantity steppers and remove links inside the tray. Delegated, because the
     tray's contents are replaced wholesale after every change. */
  if (trayBody) {
    trayBody.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-line-change]');
      if (!btn) return;
      e.preventDefault();
      btn.disabled = true;
      post(ROUTES.cartChange, {
        line: Number(btn.getAttribute('data-line-change')),
        quantity: Number(btn.getAttribute('data-qty'))
      })
        .then(refreshCart)
        .catch(function (err) { report(err); btn.disabled = false; });
    });
  }

  /* ---- quick buy -------------------------------------------------------- */
  /* Only rendered as a button when the colourway resolves to a single variant;
     otherwise the markup is a link to the product and never reaches this. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button.quick-buy[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled) return;
    btn.disabled = true;
    btn.classList.add('is-busy');
    addToCart(btn.getAttribute('data-quick-add'), 1)
      .catch(report)
      .then(function () {
        btn.disabled = false;
        btn.classList.remove('is-busy');
      });
  });

  function report(err) {
    /* Nothing in the design study is a toast, and inventing one here would be a
       new surface. The cart is the honest place for a cart failure to show, so
       say it there and open it. */
    if (trayBody) {
      var note = trayBody.querySelector('.form-note');
      if (!note) {
        note = document.createElement('p');
        note.className = 'form-note is-error';
        trayBody.insertBefore(note, trayBody.firstChild);
      }
      note.textContent = (err && err.message) || STRINGS.error;
      if (CFG.openCart) CFG.openCart();
    } else if (window.console) {
      window.console.error(err);
    }
  }

  /* ---- predictive search ------------------------------------------------ */
  var searchInput = document.getElementById('search-suggestion-field');
  var panel = document.querySelector('[data-predictive-search]');
  if (searchInput && panel) {
    var resting = panel.querySelector('[data-predictive-results]').innerHTML;
    var debounce = null;
    var lastQuery = '';

    searchInput.addEventListener('input', function () {
      var q = searchInput.value.trim();
      if (q === lastQuery) return;
      lastQuery = q;
      clearTimeout(debounce);

      /* Empty field goes back to the Browse list rather than to nothing — the
         resting state is content, not a placeholder. */
      if (q.length < 2) {
        panel.querySelector('[data-predictive-results]').innerHTML = resting;
        /* the resting list was captured in English at load */
        if (window.Tiger && Tiger.relocalize) Tiger.relocalize();
        return;
      }

      debounce = setTimeout(function () {
        var url = ROUTES.predictive + '?q=' + encodeURIComponent(q) +
                  '&resources[type]=product,collection,page&resources[limit]=6' +
                  '&section_id=predictive-search';
        fetchSection(url)
          .then(function (doc) {
            var next = doc.querySelector('[data-predictive-results]');
            if (next && lastQuery === q) {
              panel.querySelector('[data-predictive-results]').innerHTML = next.innerHTML;
              /* chrome words in the results panel (headings, "view all") arrive
                 in English; product titles have no Arabic and stay as they are */
              if (window.Tiger && Tiger.relocalize) Tiger.relocalize();
            }
          })
          .catch(function () { /* the resting list stands */ });
      }, 200);
    });
  }

  /* ---- product page ------------------------------------------------------ */
  var root = document.querySelector('[data-product-root]');
  if (root) initProduct();

  function initProduct() {
    /* No bindPdp here: on first load tiger.js has already bound the gallery,
       the accordions and the size row on these very nodes, and binding them a
       second time would toggle every accordion twice per click. bindPdp exists
       for the nodes that replace them after a colour swap. */

    /* Colour: a section re-render, because the gallery, the price, the
       reference and which sizes are in stock all change together. Doing it as
       one server render keeps them consistent by construction — there is no
       moment where the price has moved and the photograph has not. */
    root.addEventListener('click', function (e) {
      var swatch = e.target.closest('[data-colour-swatch]');
      if (!swatch) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      e.preventDefault();
      selectVariant(swatch.getAttribute('data-variant-id'), true);
    });

    /* Size: resolved locally from the variant table. No fetch — the shot and
       the price do not change with size, so a round trip would only add
       latency to a control that should feel instant. */
    root.addEventListener('click', function (e) {
      var size = e.target.closest('.pdp-size');
      if (!size || size.disabled) return;
      applySize(size);
    });

    root.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      var input = root.querySelector('[data-variant-input]');
      var button = root.querySelector('[data-add-to-cart]');
      if (!input || !input.value) return;
      if (button) button.disabled = true;
      addToCart(input.value, 1)
        .then(function () {
          var label = root.querySelector('[data-add-label]');
          if (label) {
            var was = label.textContent;
            label.textContent = STRINGS.added;
            setTimeout(function () { label.textContent = was; }, 1600);
          }
        })
        .catch(report)
        .then(function () { if (button) button.disabled = false; });
    });

    window.addEventListener('popstate', function () {
      var id = new URLSearchParams(window.location.search).get('variant');
      if (id) selectVariant(id, false);
    });
  }

  function variantData() {
    var el = root.querySelector('[data-variant-data]');
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }

  function applySize(button) {
    var id = button.getAttribute('data-variant-id');
    var input = root.querySelector('[data-variant-input]');
    if (input && id) input.value = id;

    var label = root.querySelector('[data-size-label]');
    if (label) label.textContent = button.textContent.trim();

    var data = variantData();
    var match = null;
    for (var i = 0; i < data.length; i++) {
      if (String(data[i].id) === String(id)) { match = data[i]; break; }
    }
    var addBtn = root.querySelector('[data-add-to-cart]');
    var addLabel = root.querySelector('[data-add-label]');
    if (addBtn && match) {
      addBtn.disabled = !match.available;
      if (addLabel) addLabel.textContent = match.available ? STRINGS.addToCart : STRINGS.soldOut;
    }

    /* Notify me follows the size: shown for a sold-out pair, hidden for one in
       stock, and its hidden fields re-pointed at the size just picked so the
       email the shop receives names the right pair. Only the number is
       rewritten — the word "Size" beside it is its own text node, so the Arabic
       swap in tiger-ar-extra.js keeps working on it. */
    var notify = root.querySelector('[data-notify-fields]');
    if (notify && match) {
      notify.hidden = !!match.available;
      var sizeName = button.getAttribute('data-size') || button.textContent.trim();
      var sizeInput = notify.querySelector('[data-notify-size]');
      if (sizeInput) sizeInput.value = sizeName;
      var sizeValue = notify.querySelector('[data-notify-size-value]');
      if (sizeValue) sizeValue.textContent = sizeName;
      var link = notify.querySelector('[data-notify-link]');
      if (link) link.value = link.value.split('?')[0] + '?variant=' + id;
    }

    /* Size lives in the URL too, so a chosen pair is linkable — the same
       contract the colour has. */
    var url = new URL(window.location.href);
    url.searchParams.set('variant', id);
    window.history.replaceState({}, '', url);
  }

  var pending = null;
  function selectVariant(variantId, push) {
    if (!variantId) return;
    var sectionId = root.getAttribute('data-section-id');
    var productUrl = root.getAttribute('data-product-url');
    var url = productUrl + '?variant=' + variantId + '&section_id=' + sectionId;

    root.classList.add('is-swapping');
    var token = {};
    pending = token;

    fetchSection(url)
      .then(function (doc) {
        if (pending !== token) return;   /* a faster click won */
        var next = doc.querySelector('[data-product-root]') || doc.body;
        root.innerHTML = next.innerHTML;
        bindPdp(root);

        var target = productUrl + '?variant=' + variantId;
        if (push) {
          window.history.pushState({ variant: variantId }, '', target);
        } else {
          window.history.replaceState({ variant: variantId }, '', target);
        }
      })
      .catch(function () {
        /* The swatch is a real link; letting it navigate is the correct
           fallback rather than leaving the page on the old colour. */
        window.location.href = productUrl + '?variant=' + variantId;
      })
      .then(function () {
        if (pending === token) {
          root.classList.remove('is-swapping');
          pending = null;
        }
      });
  }

  /* The gallery strip, the size row and the accordions are bound by tiger.js on
     first load. After a colour swap those nodes are new, so they are bound
     again here — the same behaviour, re-attached, not a second implementation
     layered on top of the first. */
  function bindPdp(scope) {
    var strip = scope.querySelector('[data-strip]');
    var thumbs = scope.querySelectorAll('.pdp-strip-thumb');

    if (strip && thumbs.length) {
      var mark = function (i) {
        for (var k = 0; k < thumbs.length; k++) thumbs[k].classList.toggle('is-active', k === i);
      };
      Array.prototype.forEach.call(thumbs, function (btn) {
        btn.addEventListener('click', function () {
          var i = parseInt(btn.getAttribute('data-index'), 10) || 0;
          var pane = strip.children[i];
          if (pane) strip.scrollTo({ left: pane.offsetLeft - strip.offsetLeft, behavior: 'smooth' });
          mark(i);
        });
      });
      var raf = null;
      strip.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          var w = strip.children[0] ? strip.children[0].offsetWidth : strip.clientWidth;
          mark(Math.round(strip.scrollLeft / Math.max(1, w)));
        });
      }, { passive: true });
      strip.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        var w = strip.children[0] ? strip.children[0].offsetWidth : strip.clientWidth;
        strip.scrollBy({ left: e.key === 'ArrowRight' ? w : -w, behavior: 'smooth' });
      });
    }

    Array.prototype.forEach.call(scope.querySelectorAll('.pdp-panel-head'), function (head) {
      head.addEventListener('click', function () {
        var panelEl = head.parentElement;
        var open = panelEl.classList.toggle('is-open');
        head.setAttribute('aria-expanded', String(open));
      });
    });

    var sizeRow = scope.querySelector('.pdp-size-row');
    var sizeList = scope.querySelector('.pdp-size-list');
    if (sizeRow && sizeList) {
      sizeRow.addEventListener('click', function () {
        var open = sizeList.hidden;
        sizeList.hidden = !open;
        sizeRow.setAttribute('aria-expanded', String(open));
      });
    }

    Array.prototype.forEach.call(scope.querySelectorAll('.pdp-sizes'), function (group) {
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('.pdp-size');
        if (!btn || btn.disabled) return;
        Array.prototype.forEach.call(group.children, function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });

    var back = scope.querySelector('[data-back]');
    if (back) {
      back.addEventListener('click', function (e) {
        if (history.length > 1) { e.preventDefault(); history.back(); }
      });
    }
  }
})();

/* ==========================================================================
   Drawer scroll-lock compensation.

   tiger.js locks the page by setting body.overflow = 'hidden' when the menu
   opens (.menu-toggle) and when the cart tray opens (setTray). On any pointer
   platform with a classic space-taking scrollbar, that removes the scrollbar,
   the viewport becomes ~15px wider, and every centred or full-width element on
   the page slides sideways as the drawer appears — then slides back on close.

   Fixed from here rather than in tiger.js on purpose: that file is the static
   site's own script, kept diffable against static-site/js/main.js with six
   marked exceptions, and a scrollbar is a Shopify-surface concern rather than a
   seventh exception to that contract. Nothing here changes resting layout —
   delete this block and the page renders identically, it just jumps again.

   Not `scrollbar-gutter: stable`, which would have been one line: that reserves
   the gutter permanently and so narrows every page too short to scroll — the
   cart page, 404, an empty search. This pays the width only while it is owed.
   ========================================================================== */
(function () {
  'use strict';

  var doc = document.documentElement;
  var body = document.body;
  if (!body || typeof MutationObserver !== 'function') return;

  /* The width the viewport will gain when the scrollbar goes. Zero on overlay
     scrollbars (macOS default, every touch platform) and zero on a page that
     does not scroll — in both cases zero is also the correct compensation, so
     the quiet path needs no special case.

     It has to be read *before* the lock, never after: by the time the observer
     below sees body.style change, the scrollbar is already gone and the same
     measurement reads 0. So it is taken on the way in to any interaction that
     could lock, and refreshed on resize. */
  var gutter = 0;

  function remember() {
    if (body.style.overflow !== 'hidden') {
      gutter = Math.max(0, window.innerWidth - doc.clientWidth);
    }
  }

  /* Capture phase, so this lands before the handlers in tiger.js that do the
     locking. Two integer reads per interaction — cheap enough not to throttle,
     and it keeps the reading fresh without polling. keydown is here too because
     a focused toggle opens on Enter or Space with no pointer event at all. */
  document.addEventListener('pointerdown', remember, true);
  document.addEventListener('keydown', remember, true);
  window.addEventListener('resize', remember);
  remember();

  /* Watching the lock itself rather than the things that cause it. The tray has
     four close paths (toggle, overlay, close button, Escape) and is also opened
     programmatically by CFG.openCart after an add to cart, so binding to
     controls would miss cases and go stale as soon as another one is added.
     body.style.overflow is the one signal all of them already go through. */
  function apply() {
    var want = body.style.overflow === 'hidden' && gutter ? gutter + 'px' : '';
    /* Guard the write: this mutates the attribute the observer watches, so an
       unconditional set would re-enter once per change forever. */
    if (body.style.getPropertyValue('padding-inline-end') === want) return;
    if (want) body.style.setProperty('padding-inline-end', want);
    else body.style.removeProperty('padding-inline-end');
  }

  new MutationObserver(apply).observe(body, {
    attributes: true,
    attributeFilter: ['style']
  });

  apply();
})();
